import React, { createContext, useContext } from "react";
import { TimelineVariantProps } from "./Timeline.style";

interface TimelineContextType {
  variant?: TimelineVariantProps["variant"];
  isConnected?: boolean;
}

const TimelineContext = createContext<TimelineContextType | undefined>(
  undefined
);

export const useTimelineContext = () => {
  const context = useContext(TimelineContext);
  if (!context) {
    throw new Error(
      "TimelineItem component can be used inside Timeline component"
    );
  }
  return context;
};

interface TimelineProviderProps {
  variant?: TimelineVariantProps["variant"];
  isConnected?: boolean;
  children?: React.ReactNode;
}

export const TimelineProvider: React.FC<TimelineProviderProps> = ({
  variant,
  isConnected,
  children,
}) => {
  return (
    <TimelineContext.Provider value={{ variant, isConnected }}>
      {children}
    </TimelineContext.Provider>
  );
};
